export default "__VITE_ASSET__7262bfab__"